import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/question-mark.svg";
var QuestionMarkOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  QuestionMarkOutline_default as default
};
